import { scheduleDefaults } from '@elfsight/widget-conditional-display';
import type { TimerProps } from './timer';
import type { TimerAppearance, TimerDefaultSettingsProps } from './types';

export const DEFAULT_SIZE_VALUE = 32;

export const timerDefaultSettings: TimerDefaultSettingsProps = {
  ...scheduleDefaults,
  editMode: false,
  widgetId: 'widget-id',
  id: 'id',
  timerType: 'scheduled',
  timerDuration: 24,
  durationUnit: 'hours',
  repeatTimerEnabled: false,
  remainingRestartValue: 1,
  remainingRestartUnit: 'days'
};

export const defaultUnitLabelTexts: NonNullable<TimerProps['unitLabelTexts']> =
  {
    days: 'Days',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds'
  };

export const timerDefaultAppearance: TimerAppearance = {
  timeFormat: 'auto',
  timerStyle: 'combined',
  size: DEFAULT_SIZE_VALUE,
  timerColor: '#111',
  timerBackgroundColor: '#fff',
  animation: 'none',
  showLabels: true,
  unitLabelTexts: defaultUnitLabelTexts,
  unitLabelColor: '#111',
  separatorColor: '#111',
  separatorStyle: 'colon'
};
